export class ApiBase {
	protected get baseUri() {
		return `/${this.endpoint ?? ''}`;
	}

	constructor(private readonly endpoint?: string) {
		// Empty
	}
}
